/* eslint-disable react/no-unused-state */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import config from 'config';

import MediaQueriesContext from './MediaQueriesContext';

export default class MediaQueriesProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    isDesktopBreakpoint: true,
  };

  componentDidMount() {
    this.mqDesktop = window.matchMedia(`(min-width: ${config.breakpoints.xlarge})`);
    this.mqDesktop.addListener(this.handleMediaQueryDesktop);
    this.handleMediaQueryDesktop(this.mqDesktop);
  }

  componentWillUnmount() {
    this.mqDesktop.removeListener(this.handleMediaQueryDesktop);
  }

  handleMediaQueryDesktop = mq => {
    const isDesktopBreakpoint = mq.matches;

    this.setState({ isDesktopBreakpoint });
  };

  render() {
    return (
      <MediaQueriesContext.Provider value={this.state}>
        {this.props.children}
      </MediaQueriesContext.Provider>
    );
  }
}
